var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"tab-wrapper is-hidden-desktop"},[_c('a',{staticClass:"tab",on:{"click":function($event){$event.preventDefault();return _vm.scrollToTop($event)}}},[_c('i',{staticClass:"fas fa-angle-up"})])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }